import { getCustomerDomain } from '../../../redux';
import { ApiError } from '../../../model/apiError';
import axios from 'axios';

let instance = axios.create({
  timeout: 30000
});

instance.interceptors.request.use(
  config => {
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    return config;
  }
);

instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.log(JSON.stringify(error));
     if (error.response?.status === 401) {
        return false;

    } else {
      console.log('ERROR Account/Ping', error.response, {
        statusCode: error.response?.status,
        errors: [error.response ? error.response.statusText : '']
      });

      return Promise.reject({
        statusCode: error.response?.status,
        errors: null
      } as ApiError);
    }
  }
);

export class AccountApi {

    ping = async (): Promise<boolean> => {
    const apiSuffixUrl = 'https://' + getCustomerDomain();
    //const apiSuffixUrl = 'https://localhost:44394';
      return await instance.get(`${apiSuffixUrl}/Account/Ping`, { withCredentials: true }).then(
        (response) => {
          return (response.data !== undefined) ? response.data : false;
        }
    );
  };
};
